import module from 'viaticos/module.js'

export const schema = {}

export class ViaticosExportarService {
  constructor ($http) {
    this.$http = $http
  }

  get (fechaInicial, fechaFinal, reporte, filtro) {
    let params = {reporte, filtro}
    if (fechaInicial) {
      params.fecha_inicial = fechaInicial.toISOString().slice(0, 10)
    }
    if (fechaFinal) {
      params.fecha_final = fechaFinal.toISOString().slice(0, 10)
    }
    return this.$http.get('api/viaticos/viaticos/exportar', {
      params,
      schema,
      download: true,
    })
  }
}

module.service('ViaticosExportarService', ViaticosExportarService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Exportar.js